import { evaluate, equal } from "mathjs"

export const isPoint = (str: string) => {
    
    try {
        var strLeft = str.charAt(0);
        var strRight = str.charAt(str.length-1);

        if (strLeft !== '(' || strRight !== ')') {
            return { 
                ok: false, 
                title: '¡Cuidado!',
                msg: 'Los extremos del vector son: ( y )'
            }
        }

        var strCenter = str.substring(1,str.length-1);
        var strArray = strCenter.split(",");

        const arreglo =[]

        for (var i = 0; i < strArray.length; i++) {
            arreglo.push(isNaN(evaluate(strArray[i])))
        }

        const long = arreglo.filter(Boolean).length
        
        if (long === 0) {
            return { 
                ok: true, 
                title: 'Exito',
                msg: `${str} es un vector`
            }
        } else {
            return { 
                ok: false, 
                title: '¡Cuidado!',
                msg: 'No has ingresado una respuesta'
            }
        }
    } catch (error) {
        return { 
            ok: false, 
            title: '¡Cuidado!',
            msg: 'Tu respuesta no representa un vector'
        }
    }

}

export const equalPoints = (vectorDataBase: string, vectorUser: string) => {

    try {
        // Quitando ( y ) en los extremos de la matriz
        var strCenterUno = vectorDataBase.substring(1,vectorDataBase.length-1);
        var strCenterDos = vectorUser.substring(1,vectorUser.length-1);
        // Mandando las coordenadas o componentes del vector a un arreglo
        var strArrayUno = strCenterUno.split(",");
        var strArrayDos = strCenterDos.split(",");

        const arreglo = []

        for (var i = 0; i < strArrayUno.length; i++) {
            arreglo.push(equal(evaluate(strArrayUno[i]),evaluate(strArrayDos[i])))
        } 

        const long = arreglo.filter(Boolean).length
        if (long === strArrayDos.length) {
            return { 
                ok: true, 
                title: 'Exito',
                msg: 'Has encontrado el vectos solución'
            }
        } else {
            return { 
                ok: false, 
                title: 'Error',
                msg: 'Tu respuesta no coincide con el vector solución'
            }
        }
    } catch (error) {
        return { 
            ok: false, 
            title: 'Error',
            msg: 'Tu respuesta no coincide con el vector solución'
        }
    }
}